export default "__VITE_ASSET__Diu5E6hj__"